module.exports = __webpack_public_path__ + "static/bg1440-0e2b82c0b15e83765c1f20ac20ed770f.jpg";